module.exports = __webpack_public_path__ + "img/梅花中级大师@3x.8872f0c2.png";